var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('div',[_c('div',{staticClass:"invoice-container",domProps:{"innerHTML":_vm._s(_vm.invoiceHtml)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }